import styled from "@emotion/styled";
import theme from "../../styles/theme";

interface IRichTextContentBaseProps {
  isHighlighted: boolean | any | undefined;
}

export const RichTextContentBase = styled.div<IRichTextContentBaseProps>`
  ${(props) =>
    props.isHighlighted &&
    `
    background-color: ${theme.colors.blues[10]};
    padding: 2rem !important;
    border-radius: 0.5rem;

    h2 {
      margin-top: 0;
    }
  `}

  &.no-top-padding {
    padding-top: 0;
  }

  &.no-bottom-padding {
    padding-bottom: 0;
  }

  &.no-top-and-bottom-padding {
    padding-top: 0;
    padding-bottom: 0;
  }

  ${theme.largerThan["2xl"]} {
    padding-left: 0;
    padding-right: 0;
  }
`;

export const Content = styled.div`
  ${theme.text.base};
  color: ${theme.colors.darkBlues[90]};

  h2 {
    margin-bottom: 1rem;
  }

  & p:not(:last-child) {
    margin-bottom: ${theme.space[4]};
  }

  ${theme.largerThan.lg} {
    &.text-medium {
      p {
        ${theme.text.xl};
      }
    }
  }
`;

export const Section = styled.section`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    &:hover .heading-anchor {
      opacity: 1;
    }

    .heading-anchor {
      opacity: 0;
    }
  }
`;

export const LinkIcon = styled.a`
  position: absolute;
  margin-left: -2em;
  margin-top: 3px;
  font-size: 0.5em;
  color: ${theme.colors.darkBlues[90]};
  opacity: 0;
`;
